import { Section } from "@react-email/components";

const Regards = () => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    color: '#3E3E4A',
                    fontFamily: 'Poppins,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                    marginTop: "20px",
                    marginBottom: "5px",
                }}
            >
                Best regards,
            </div>

            <div
                style={{
                    display: 'flex',
                    color: '#555',
                    fontFamily: 'Poppins,sans-serif',
                    fontSize: '16px',
                    fontStyle: 'normal',
                    fontWeight: 700,
                    lineHeight: 'normal',
                }}
                className="beSeen"
            >
                The Be:Seen Team
            </div>
        </>
    );
};
export default Regards;
